import { __awaiter, __generator } from "tslib";
import { getSiteFeaturesUrl } from './utilities/get-site-features-url';
import { getSiteFeatureFromSessionStorage } from './utilities/get-site-feature-from-session-storage';
import { fetchGet } from '../../common/http/fetch-get';
/**
 * Fetchs for site features
 * @param siteFeatures Array of `SiteFeature` enumeration values
 * @returns A promise that resolves with array of feature toggles from API.
 */
export var fetchSiteFeatures = function (siteFeatures) { return __awaiter(void 0, void 0, void 0, function () {
    var siteFeaturesUrl, siteFeaturesFromAPI;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                siteFeaturesUrl = getSiteFeaturesUrl(siteFeatures);
                return [4 /*yield*/, fetchGet(siteFeaturesUrl)];
            case 1:
                siteFeaturesFromAPI = (_a.sent()) || [];
                // Re-assigns values from session storage
                siteFeaturesFromAPI.forEach(function (x) {
                    var valueInSessionStorage = getSiteFeatureFromSessionStorage(x.name);
                    if (valueInSessionStorage !== undefined) {
                        x.value = valueInSessionStorage.value;
                    }
                });
                return [2 /*return*/, siteFeaturesFromAPI];
        }
    });
}); };
